import { createReducer, on } from "@ngrx/store";
import { featureFlagAdopterHubInitialState } from "./feature-flag-adopter-hub.state";
import * as featureFlagAdopterHubActions from "./feature-flag-adopter-hub.actions";
import * as _ from "lodash";

export const featureFlagAdopterHubReducer = createReducer(
  featureFlagAdopterHubInitialState,
  on(featureFlagAdopterHubActions.loadFeatureFlagAdopterHub, (state) => state),
  on(featureFlagAdopterHubActions.setFeatureFlagAdopterHub, (state, { featureFlagAdopterHub }) => ({
    ..._.cloneDeep(state),
    initialState: false,
    featureFlagAdopterHub
  })),
  on(featureFlagAdopterHubActions.resetFeatureFlagAdopterHub, () => featureFlagAdopterHubInitialState)
);
